
import Vue from "vue";
import { IChapter } from "../store/state";

interface ChaptersListProps {
  chapter: IChapter;
}

export default Vue.extend<{}, {}, {}, ChaptersListProps>({
  name: "ChaptersList",
  props: {
    chapter: {},
  },
  computed: {
    hideTopLevel() {
      return this.$store.getters.hideTopLevel;
    },
    hasThirdLevel() {
      return this.$store.getters.hasThirdLevel;
    },
  },
});
